import TerminatorCurrentPick from './TerminatorCurrentPick'
import TerminatorPickReport from './TerminatorPickReport'
import terminatorErrorMessage from './terminatorErrorMessage'
import TerminatorPayment from './TerminatorPayment'
import TerminatorReminders from './TerminatorReminders'
import { getMainPageData, doSignUp, canRegisterForSeason, cancelRegistration } from '@severed-links/common.redherrings-reducers/terminator'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Alert, Button, Row, Col } from 'react-bootstrap'
import TerminatorInstructions from './TerminatorInstructions'
import * as s from '../Eliminator/EliminatorIntro.scss'

const TerminatorHome = () => {
  const dispatch = useDispatch()
  const state = useSelector(state => state.terminator)
  const data = state.mainPage
  const [paymentNoticeTarget, setPaymentNoticeTarget] = useState(null)
  const [now, setNow] = useState(Date.now())
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(timer)
  }, [])
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const [refresh, setRefresh] = useState(0)
  useEffect(() => {
    let active = true
    setError('')
    dispatch(getMainPageData()).then(action => {
        const payload = action?.payload
        if (action?.error || !payload || payload.messageType === 'error') throw new Error(payload?.response?.message || payload?.message || 'Unable to load Terminator. Please try again.')
        return payload
      }).catch(error => { if (active) setError(terminatorErrorMessage(error)) })
    return () => { active = false }
  }, [dispatch, refresh])
  const cancel = async () => {
    setBusy(true)
    try {
      const action = await dispatch(cancelRegistration(data.config.seasonId))
      if (action.error || action.payload?.messageType === 'error') throw new Error(action.payload?.response?.message || action.payload?.message || 'Unable to cancel registration.')
      setRefresh(v => v + 1)
    } catch (error) { setError(terminatorErrorMessage(error)) }
    setBusy(false)
  }
  const register = async () => {
    setBusy(true)
    setError('')
    try {
      await dispatch(doSignUp(data.config.seasonId)).then(action => {
        const payload = action?.payload
        if (action?.error || !payload || payload.messageType === 'error') throw new Error(payload?.response?.message || payload?.message || 'Unable to load Terminator. Please try again.')
        return payload
      })
      setRefresh(value => value + 1)
    } catch (error) { setError(terminatorErrorMessage(error)) }
    setBusy(false)
  }
  return <main className={s.container}>
    {error ? <Alert variant='danger'>{error} <Button onClick={() => setRefresh(value => value + 1)}>Retry</Button></Alert> : null}
    {!data && !error ? <p role='status'>Loading Terminator…</p> : null}
    {data ? <Row className={s.layout}>
      <Col lg={7} md={6} sm={12}>
        <section className={s.mainPanel}>
          <div className={s.hero}><div className={s.eyebrow}>Terminator</div><h2>Welcome to the {data.config.seasonName || 'new season of'} Terminator!</h2></div>
          <div ref={setPaymentNoticeTarget} />
          {data.config.frontPageMessage ? <Alert variant='info'>{data.config.frontPageMessage}</Alert> : null}
          <TerminatorCurrentPick /><div className={s.instructions}><TerminatorInstructions eliminationMode={data.config.eliminationMode} startWeek={data.config.startWeek ?? 1} /></div>
        </section>
      </Col>
      <Col lg={5} md={6} sm={12}>
        <aside className={s.sidePanel}>
          <section className={s.mainPanel}>
            <h4>Season registration</h4>
            <p>{data.playerCount} registered · Entry fee: ${Number(data.config.entryFee).toFixed(2)}</p>
            {data.isRegistered ? <Alert variant='success'>You are registered for this season.</Alert> : canRegisterForSeason(state, now) ?
              <Button disabled={busy} onClick={register}>{busy ? 'Registering…' : 'Sign me up!'}</Button> : <p>Season registration is closed.</p>}
          </section>
          {data.isRegistered && canRegisterForSeason(state, now) ? <Button variant='outline-secondary' disabled={busy} onClick={() => { if (window.confirm('Cancel your unpaid registration? Entries with payments or saved picks require an administrator.')) cancel() }}>Cancel registration</Button> : null}
          {data.isRegistered ? <><TerminatorPayment seasonId={data.config.seasonId} noticeTarget={paymentNoticeTarget} /><TerminatorReminders data={data} /></> : null}
          <TerminatorPickReport />
        </aside>
      </Col>
    </Row> : null}
  </main>
}
export default TerminatorHome
